export const en = {
    translation: {
        accounts: {
            label: "Account"
        },
        aitree: {
            launch: "Launch Chat",
            api: {
                title: "API Connections"
            },
            dossier: {
                title: "Dossier Configuration"
            },
            node: {
                displayTitle: "Display",
                icon: "Icon",
                label: "Name"
            } 
        },
        analysis: {
            showSource: "Show Upload",
            showAnalysis: "Show Analysis",
            showMapping: "Show Mapping",
            showImportData: "Show Imported Data",
            refresh: "Refresh Data"
        },
        alert: {
            saved: "Saved",
            update: "Updated",
            validated: "Validated"
        },
        apis: {
            addApis: "Add API",
            name: "API Name",
            noLinesAvailable: "No APIs configured",
            label: {
                name: "API Name",
                endpoint: "Endpoint",
                description: "Description",
                method: "Method",
                secret: "Secret",
                last_run_at: "Last Executed",
                title: "APIs",
                enabled: "Enabled",
                interval: "Execute every ... minutes"
            },
            title: "APIs",
            button: {
                addApi: "Add API",
                execute: "Execute"
            },
            options: {
                method: {
                    rest: "REST",
                    googleSheet: "Google Sheet"
                }
            }
        },
        address: {
            showMap: "Show on Map",
            title: "Addresses", 
            add: "Add Adress",
            label: {
                name: "Label",
                street: "Street",
                city: "City",
                state: "State",
                postal_code: "Postal Code",
                country: "Country",
                address_type: "Type"
            }
        },
        assistant: {
            talk: "Read out loud",
            stopTalking: "Stop reading",
            feedback: "Provide Feedback",
            title: "Personal Assistant",
            noAnswerNeeded: "No answer needed"
        },
        aicontrol: {
            header: {
                confirmAction: "Confirm Deletion"
            },
            message: {
                delete: "Are you sure you want to delete this node? This action cannot be undone."
            }
        },
        auth: {
            "username_password": "Username and Password",
            "google_oauth": "Google OAuth",
            "microsoft_oauth": "Microsoft OAuth",
            "loginWithGoogle": "Login with Google",
            "loginWithMicrosoft": "Login with Microsoft"
        },
        avatars: {
            emptyList: "No avatars found",
            emptyListTab: "No avatars found in \"{{tab}}\"",
            label: {
                name: "Name",
                title: "Title",
                image_url: "Image URL",
                video_url: "Video URL",
                description: "Description",
                is_deleted: "Deleted",
                is_enabled: "Enabled",
                created_at: "Created At"
            },
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                delete: "Delete all {{selected}}"
            },
            new: "New Avatar",
            search: {
                button: "Search Avatar",
                placeholder: "Search..."
            },
            tab: {
                all: "All Avatars",
                deleted: "Deleted Avatars"
            },
            table: {
                select: "Select",
                name: "Name",
                title: "Title",
                image_url: "Image URL",
                video_url: "Video URL",
                description: "Description",
                delete: ""
            },
            upload: "Upload Avatars"
        },
        bank_accounts: {
            emptyList: "No bank accounts found",
            emptyListTab: "No bank accounts in \"{{tab}}\" found",
            label: {
                account_holder: "Account Holder",
                iban: "IBAN",
                bic: "BIC",
                is_deleted: "Deleted",
                created_at: "Created At"
            },
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                delete: "Delete all {{selected}}"
            },
            new: "New Bank Account",
            search: {
                button: "Search Bank Account",
                placeholder: "Search..."
            },
            tab: {
                all: "All Bank Accounts",
                deleted: "Deleted Bank Accounts"
            },
            table: {
                select: "Select",
                account_holder: "Account Holder",
                iban: "IBAN",
                bic: "BIC",
                delete: ""
            },
            upload: "Upload Bank Accounts"
        },        
        button: {
            add: {
                entry: "Add item",
                api: "Add API",
                avatar: "Add Avatar",
                backgroundTask: "Add Background Task",
                classification_entries: "Add Class",
                classification_groups: "Add Classification",
                multimedia: "Add Multi Media Material",
                note: "Add Note",
                phrase: "Add Phrase",
                prompt: "Add Prompt",
                standardmessage: "Add Standard Message",
                tenantUser: "Add User",
                todo: "Add Todo",
                image: "Add Image",
                dossierKey: "Add Key",
                team_member: "Add Team Member",
                email: "Add Channel",
            },
            openDetails: "Open Detail View",
            enterFullscreen: "Full screen",
            exitFullscreen: "Next to each other",
            run:{
                backgroundTask: "Run Background Tasks"
            },
            calendar: "Calendar View",
            customer: {
                sync: "Sync Customers"
            },
            delete: "Delete",
            download: "Datei herunterladen",
            diagram: "Diagram View",
            done: "Done",
            edit: "Edit View",
            email: {
                show: "Show Email",
                sync: "Fetch Emails"
            },
            inspiration: "Inspiration View",
            kanban: "Kanban View",
            list: "List View",
            read: "Mark as read",
            refetch: "Try again",
            unread: "Mark as unread",
            update: "AI Update",
            undelete: "Undo Delete",
            upload: "Upload new Media",
            cancel: "Cancel"
        },
        categorySelector: {
            add: "Add {{key}}",
            placeholder: "Add categories...",
            emptyResult: "No categories found",
            edit: "Edit categories"
        },
        chat: {
            input: {
                placeholder: "Let's practice English"
            },
            menu: {
                switchToCurriculum: "Switch to lesson conversation",
                switchToFreestyle: "Switch to freestyle conversation",
                unmute: "Unmute",
                mute: "Mute",
                enableWriteChat: "Let me write",
                enableVoiceChat: "Let me talk",
                translateToEnglish: "Translate this word or phrase",
                suggest: "Give me an example",
                correctImmediately: "Correct me immediately",
                correctAtTheEnd: "Correct me at the end",
                showMistakeInChat: "Show mistakes in the chat",
                dontShowMistakeInChat: "Hide mistakes in the chat",
                pronounce: "Pronounce this word or phrase",
                repeat: "Repeat",
                correctBasic: "Switch to basic correction mode",
                correctC2: "Switch to advanced correction mode"
            },
            correction: {
                condensedErrors: "Overall rating, grammar and spelling mistakes"
            },
            error: {
                missingChatId: "The chat ID is invalid"
            }
        },        
        chats: {
            emptyList: "No chats found",
            emptyListTab: "No chats found in \"{{tab}}\"",
            media: {
                name: "Media Topic",
                description: "Description",
                type: "Media Type",
                link: "Media Link",
                calltoaction: "Call to Action",
                thumbnailimage: "Thumbnail Image",
                title: "Chat Media",
                add: "Add Media",
                selectName: "Select a Media Name"
            },
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                avatar_type: "Change voice for all {{selected}}",
                conversation_starter: "Change start for all {{selected}}",
                chat_design_id: "Change design for all {{selected}}",
                delete: "Delete all {{selected}}"
            },
            options: {
                chatType: {
                    did: "D-ID Integration",
                    elevenlabs: "ElevenLabs Integration",
                    elevenlabsTest: "Test ElevenLabs Integration",
                    browservoice: "Web Browser Voice"
                },
                mediaType: {
                    image: "Image",
                    deflect: "Deflect",
                    video: "Video"
                },
                paramType: {
                    contact: "Contact ID",
                    knowledge: "Knowledge Base ID",
                    product: "Product ID",
                    order: "Order ID",
                    custom: "Custom"
                },
                paramSource: {
                    url: "URL",
                    chat: "Chat"
                },
                paramUsage: {
                    analysis: "Analysis",
                    chat: "Chat"
                },
                conversationStarter: {
                    customer: "Customer",
                    chat: "Chat (static)",
                    agent: "Agent"
                }
            },
            params: {
                addParam: "Add Parameter",
                name: "Parameter Name",
                description: "Description",
                type: "Parameter Type",
                default_value: "Default Value",
                source: "Source",
                usage: "Usage",
                selectName: "Select a Parameter Name"
            },
            search: {
                placeholder: "Search..."
            },
            settings: {
                name: "Chat Name",
                description: "Description",
                conversation_headline: "Conversation Headline",
                conversation_starter: "Conversation Start",
                conversation_subline: "Conversation Subline",
                conversation_opening_text: "Conversation Opening Text",
                avatar_width: "Avatar Width",
                avatar_height: "Avatar Height",
                avatar_type: "Avatar Type",
                voice_name: "Voice Name",
                voice_software_key: "Voice Software Key",
                notes_activated: "Notes Activated",
                picture: "Picture Upload",
                video: "Video Upload",
                title: "Chat Settings",
                addChat: "Add Chat",
                selectName: "Select a Chat Name"
            },
            tab: {
                all: "All Chats",
                recent: "Recent Chats",
                deleted: "Deleted Chats"
            },
            table: {
                select: "Select",
                picture_upload_id: "Avatar",
                name: "Name",
                description: "Description",
                avatar_type: "Voice",
                conversation_starter: "Start",
                chat_design_id: "Design",
                delete: ""
            }
        },
        chat_sessions: {
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                delete: "Delete all {{selected}}"
            },
            tab: {
                all: "All Chats",
                recent: "Recent Chats",
                deleted: "Deleted Chats"
            },
            search: {
                placeholder: "Search..."
            },
            label: "Chats",
            table: {
                select: "Select",
                contact_id: "Customer",
                lastchatactivity: "Last Activity",
                label: "Conversation Stage",
                stagecompletion: "Stage Progress",
                leadscore: "Lead Score",
                evaluationtext: "AI Evaluation",
                delete: ""
            },
            emptyList: "No conversation notes found",
            emptyListTab: "No conversation notes found in \"{{tab}}\"",
            new: "Create New Conversation Note",
            upload: "Upload Conversation Notes"
        },
        classification: {
            label: {
                object_type: "Object Type",
                name: "Name",
                description: "Description",
                is_single_selection: "Single Selection",
                is_primary_category: "Primary Category",
                is_pre_classify: "Pre-classify",
                text_analysis_length: "Text Analysis Length",
                requires_response: "Requires Response",
                requires_analysis: "Requires Analysis",
                rule_type: "Rule Type",
                rule_sql: "Rule Code (SQL)"
            }
        },
        contact_relationships: {
            emptyList: "No contact relationships found",
            emptyListTab: "No contact relationships in \"{{tab}}\" found",
            label: {
                type: "Relationship Type",
                from_contact_id: "From Contact",
                to_contact_id: "To Contact",
                is_deleted: "Deleted",
                created_at: "Created At"
            },
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                delete: "Delete all {{selected}}"
            },
            new: "New Contact Relationship",
            search: {
                button: "Search Contact Relationship",
                placeholder: "Search..."
            },
            tab: {
                all: "All Contact Relationships",
                deleted: "Deleted Contact Relationships"
            },
            table: {
                select: "Select",
                type: "Relationship Type",
                from_contact_id: "From Contact",
                to_contact_id: "To Contact",
                delete: ""
            },
            upload: "Upload Contact Relationships"
        },
        contracts: {
            emptyList: "No Contracts Found",
            emptyListTab: "No contracts found in \"{{tab}}\"",
            new: "New Contract",
            search: {
                button: "Search Contract",
                placeholder: "Search..."
            },
            tab: {
                all: "All Contracts",
                deleted: "Deleted Contracts"
            },
            label: {
                product_id: "Id",
                contact_id: "Customer",
                name: "Name",
                notes: "Notes",
                type: "Type",
                created_at: "Creation Date",
                start_date: "Start Date",
                end_date: "End Date",
                status: "Status"
            },
            table: {
                product_id: "Id",
                contact_id: "Customer",
                name: "Name",
                notes: "Notes",
                type: "Type",
                start_date: "Start Date",
                end_date: "End Date",
                status: "Status"
            },
            upload: "Upload Contracts"
        },  
        coach: {
            title: "Sales Coach",
            label: {
                OverallRating: "Overall Rating",
                Summary: "Summary",
                SuggestedImprovement: "Suggested Improvement",
                Spelling: "Spelling",
                Precision: "Precision",
                Professionalism: "Professionalism",
                Friendliness: "Friendliness",
                Clarity: "Clarity",
                Conciseness: "Conciseness",
                Engagement: "Engagement",
                StructureFlow: "Structure & Flow",
                GrammarSyntax: "Grammar & Syntax",
                ToneConsistency: "Tone Consistency",
                Actionability: "Actionability",
                Relevance: "Relevance",
                Personalization: "Personalization",
                BrandConsistency: "Brand Consistency",
                CTAIncluded: "CTA Included"
            },
            section: {
                details: "Detailed Analysis"
            },
            button: {
                proofRead: "Proofread",
                reformulate: "Incorporate Suggestion"
            }, 
        },  
        copy: {
            clipboard: "Copy to clipboard",
            note: "Create a Note",
            text: "Do you want me to memorize the highlighted text?",
            title: "Selected Email text",
            todo: "Create a Todo"
        },
        customer: {
            analysis: "AI Analysis",
            analytics: {
                title: "Customer Analytics"
            },
            fillAI: "Complete Profile with AI",
            logMeeting: "Log Meeting",
            addNote: "Add Note",
            addOrder: "Create Order",
            addTodo: "Create Todo",
            details: "Details",
            filter: {
                owner: "Owner",
                verified: "Verified",
                type: "Type"
            },
            label: {
                firstname: "First Name",
                additionalFirstNames: "Middle Names",
                lastname: "Last Name",
                birthday: "Date of Birth",
                companyName: "Company Name",
                email: "Email Address",
                phone: "Primary Phone Number",
                title: "Title",
                type: "Contact Type",
                satisfaction: "Satisfaction",
                upsellPotential: "Upsell Potential",
                nextStepForCustomer: "Next Steps",
                suitableForEmailCampaign: "Suitable for Proactive Outreach",
                language: "Language",
                qualificationStatus: "Qualification Status",
                interactionStatus: "Interaction Status",
                email_bounce: "Email Delivery Failed",
                email_verified: "Email Verified",
                advertisement_consent: "Advertisement Consent",
                advertisement_ban: "Advertisement Ban",
                is_control_group: "Is Control Group",
                last_interaction_date: "Last Interaction Date",
                entityType: "Type",
                responsible: "Account Manager",
                source: "Lead Source"
            },
            interaction: "Customer Interaction",
            options: {
                qualificationStatus: {
                    mql: "MQL",
                    sql: "SQL",
                    blocked: "No Communication"
                },
                interactionStatus: {
                    new: "New",
                    contactAttempted: "Contact Attempted",
                    contactWithPotential: "Contact with Potential",
                    pause: "Do Not Call for Now",
                    badTiming: "Bad Timing",
                    openDeal: "Open Deal",
                    customer: "Customer",
                    parked: "Parked",
                    disqualified: "Disqualified"
                },
                entityType: {
                    all: "All",
                    person: "Person",
                    company: "Company"
                },
                sourceType: {
                    linkedIn: "LinkedIn",
                    flyer: "Flyer",
                    friend: "Friend",
                    mail: "Email",
                    google: "Google",
                    instagram: "Instagram",
                    magazine: "Magazine",
                    source: "Source"
                }
            },
            sendEmail: "Send Email",
            alert: {
                isDeleted: "This contact has been deleted"
            }
        },
        customers: {
            emptyList: "No Customers Found",
            emptyListTab: "No contacts found in \"{{tab}}\"",
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                user_id: "Change owner for all {{selected}}",
                contact_type: "Change category for all {{selected}}",
                is_verified: "Change verification status for all {{selected}}",
                delete: "Delete all {{selected}}"
            },
            new: "New Customer",
            search: {
                button: "Search Customer",
                placeholder: "Search..."
            },
            tab: {
                all: "All verified Contact",
                prospect: "Prospects",
                customer: "Customers",
                colleague: "Colleagues",
                partner: "Partners",
                supplier: "Suppliers",
                applicant: "Applicants",
                deleted: "Deleted",
                duplicate: "Duplicates",
                blocked: "Non Customers",
            },
            table: {
                user_id: "Owner",
                contact_type: "Category",
                firstname: "First Name",
                lastname: "Last Name",
                companyName: "Company Name",
                position: "Position",
                is_verified: "Verification",
                select: "Select",
                delete: "",
                workflow_status: ""
            },
            upload: "Upload Customers",
        },
        communication_plans: {
            add: "Add Communication Plan",
            new: "Add Communication Plan",
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                status: "Change status for all {{selected}}",
                delete: "Delete all {{selected}}"
            },
            emptyList: "No communication plan found.",
            emptyListTab: "No communication plans found in \"{{tab}}\"",
            channels: {
                email: "Add email communication",
                sms: "Add SMS communication",
                whatsapp: "Add WhatsApp communication",
                signal: "Add communication via Signal Messenger",
                event: "Add an event",
                training: "Add a training session",
                linkedin: "Add LinkedIn communication",
            },
            label: {
                name: "Name",
                event_response: "Reaction to Customer Interaction",
                description: "Description",
                status: "Status",
            },
            tab: {
                all: "All",
                deleted: "Deleted Communication Plans",
            },
            table: {
                select: "Select",
                name: "Name",
                description: "Description",
                status: "Status",
                delete: ""
            },
            search: {
                placeholder: "Search..."
            },
            select: "Select Communication Plan"            
        },        
        communication_steps: {
            label: {
                name: "Name",
                type: "Type of communication",
                is_customized: "Customize the communication for individual recipients?",
                customization_sources: "Sources of information for customization",
                status: "Status",
                subject: "Communication subject",
                content: "Communication content",
            },       
        },  
        companyRelation: {
            add: "Add Position",
            companiesTitle: "Position",
            employeesTitle: "Employees",
            label: {
                person: "Employee Details",
                company: "Company Details",
                relationType: "Relationship",
                position: "Position",
                department: "Department",
                startDate: "Start Date",
                endDate: "End Date"
            }
        },      
        crossSell: {
            label: {
                source_product_id: "Source Product ID",
                target_product_id: "Target Product ID",
                probability: "Probability",
                trigger_after_mins: "Trigger After (Minutes)",
                type: "Type",
                is_active: "Active",
                target_image_url: "Target Product Preview",
                selectTargetProduct: "Select Target Product"
            },
            options: {
                type: {
                    upsell: "Up-Sell",
                    crosssell: "Cross-Sell",
                    repurchase: "Repurchase"
                }
            },
            title: "Cross-Sell Products",
            button: {
                addCrossSell: "Add Cross-Sell"
            }
        },
        detailView: {
            noItemSelected: "No item selected"
        },
        documents: {      
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                delete: "Delete all {{selected}}"
            },
            tab: {
                all: "All Documents",
                deleted: "Deleted Documents"
            },
            search: {
                placeholder: "Search..."
            },
            label: "Documents",
            table: {
                select: "Select",
                document_type: "Document Type",
                language: "Language",
                category: "Category",
                status: "Status",
                owner_user_id: "User",
                issued_at: "Issue Date",
                expires_at: "Expiry Date",
                delete: ""
            },
            emptyList: "No documents found",
            emptyListTab: "No documents found in \"{{tab}}\"",
            label: {
                document_type: "Document Type",
                language: "Language",
                category: "Category",
                status: "Status",
                owner_user_id: "User",
                upload_id: "Original Document",
                expires_at: "Expiry Date",
                issued_at: "Issue Date",
                user_provided_data: "Included Information",
                case_number: "Case Number",
                monthly_amount: "Monthly Amount",   
            },
            new: "Create New Document",
            upload: "Upload Document",
            options: {
                document_type: {
                    bescheid: "Notice",
                    nachfragevomamt: "Request from authority",
                    nachfrageansamt: "Request to authority",
                    antrag: "Application"
                },
                category: {
                    kindergeld: "Child Benefit",
                    bürgergeld: "Basic Income",
                    bildungundteilhabe: "Education and Participation",
                    wohngeld: "Housing Benefit",
                    kinderzuschlag: "Child Supplement",
                    unterhaltsvorschussgesetz: "Advance Maintenance Law",
                    kinderbetreuung: "Childcare",
                    aufenthaltserlaubnis: "Residence Permit"
                }
            },     
        },
        email: {
            action: {
                edit: "Edit"
            },
            alert: {
                delete: "Email deleted",
                fail: "Send email failed",
                recalc: "Processing Email...",
                recalcSuccess: "Email Updated",
                sent: "Email Sent",
                unread: "Email marked as unread",
                sending: "Sending..."
            },
            analytics: {
                noAnalyticsTitle: "No Analysis Available",
                wait: "The email has not been analyzed yet",
                noAnalysisNeeded: "Analysis seems unnecessary for this email",
                error: "The email could not be analyzed",
                analyze: "Analyze",
                noAnalysis: "No analysis available",
                notVerified: "The sender is not verified as a customer",
                noAnalysisDesc: "Sorry, I could not analyze this email.",
                shouldAnalyze: "Analyze email?",
                analyzeThis: "Analyze this email",
                allAnalyzed: "Currently, all emails from this contact are being analyzed.",
                analyzeContact: "Analyze all emails from this contact",
                noneAnalyzed: "Currently, no emails from this contact are being analyzed.",
                blockContact: "Do not analyze emails from this contact",
            },                     
            analyticsStatus: {
                ANALYZED: "Analyzed",
                NO_ANALYSIS_NEEDED: "No analysis planned",
                ERROR: "Analysis not possible",
                NOT_ANALYZED: "Not yet analyzed",
                SENDER_NOT_VERIFIED: "Analysis not enabled for this contact",
                SENDER_BLOCKED: "Analysis disabled for this contact"
            },            
            assistant: {
                tab: {
                    answer: "Answer",
                    discuss: "Discuss",
                    understand: "Understand",
                    customer: "Overview",
                    write: "Write",
                }
            },
            button: {
                extend: "Extended receiver information"
            },
            confirmationModal: {
                title: "Send Email",
                missingToAddress: "The email does not have a valid recipient.",
                missingSubject: "The email does not have a subject. Send anyway?",
                missingBody: "The email does not have a body. Send anyway?",
                send: "Send Anyway"
            },
            event: {
                Organizer: "Organizer",
                Starts: "Starts",
                Ends: "Ends",
                Location: "Location",
                Attendee: "Attendee",
                NoLocation: "No location",
                NoAttendee: "No attendee"
            },
            options: {
                workflowStatus: {
                    new: "New",
                    in_progress: "In Progress",
                    done: "Done",
                    archieved: "Archived"
                }
            },
            regards: "Best Regards",
            schedule: {
                sending: "Email is being sent...",
                timeLabel: "Scheduled to send at:",
                canceling: "Email is being canceled...",
                cancelScheduledTime: "Cancel Scheduled Time",
                confirmCancelScheduledTime: "Are you sure you want to cancel the scheduled time?"
            },
            label: {
                to: "To:",
                ccs: "CC:",
                bccs: "BCC:",
                from: "From:",
                subject: "Subject:",
                time: "Scheduled Send Time:",
                acceptSuggestedTime: "Accept suggested time",
                rejectSuggestedTime: "Reject suggested time"
            },
            scheduleWarning: {
                weekend: "Send time falls on a weekend.",
                outsideBusinessHours: "Send time is outside business hours."
            },
            prompt: {
                answer: "Prompt for answering emails",
                analysis: "Prompt for email analysis"
            },
            separator: {
                at: "Am",
                wrote: "schrieb"
            },
            sendAll: "Send to all"
        },
        account_settings: {
            headline: "Communication Channels",
            emptyList: "No email settings found",
            emptyListTab: "No settings found in \"{{tab}}\"",
            label: {
                email: "Email",
                username: "Username",
                from_name: "Sender Name",
                imap: "IMAP Server",
                smtp: "SMTP Server",
                is_active: "Active",
                is_deleted: "Deleted",
                is_default: "Default",
                check_spam: "Check Spam",
                spam_threshold: "Spam Threshold",
                email_analysis_days_back: "Analysis Period (Days)",
                email_download_start_date: "Download Start Date",
                auth_method: "Authentication Method",
                logo_upload_id: "Logo Upload ID",
                password: "Password"
            },
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                delete: "Delete all {{selected}}"
            },
            new: "New Email Setting",
            search: {
                button: "Search Setting",
                placeholder: "Search..."
            },
            tab: {
                all: "All Settings",
                deleted: "Deleted Settings"
            },
            table: {
                select: "Select",
                email: "Email",
                username: "Username",
                from_name: "Sender Name",
                imap: "IMAP",
                smtp: "SMTP",
                auth_method: "Authentication",
                is_active: "Active",
                delete: ""
            },
            upload: "Upload Settings"
        },
        events: {
            emptyList: "No campaigns found.",
            emptyListTab: "No campaigns found in \"{{tab}}\"",
            filterTree: {
                addressField: {
                    streetFilter: "Street filter",
                    cityFilter: "City filter",
                    stateFilter: "State filter",
                    postalCodeFilter: "Postal code filter",
                    countryFilter: "Country filter",
                },
                create: "Create filter tree",
                title: "Participant filter",
                addFilters: "Add filters",
                nodeTypes: {
                    audience: "All potential participants before filtering.",
                },
                button: {
                    add: "Add",
                    validEmailAddress: "Participants with a valid email address",
                    noDoubleCommunication: "No communication in the last 2 weeks",
                    advertisingPermission: "Only with advertising permission",
                    executeTree: "Apply filter",
                    AddressFilter: "Address filter",
                    Category: "Category",
                    advertisingBan: "Advertising ban",
                },
                description: {
                    keepAll: "This filter includes all participants without applying any restrictions or filtering.",
                    validEmailAddress: "This filter excludes participants whose email addresses are invalid or bounced.",
                    noDoubleCommunication: "This filter excludes participants who were contacted within a configurable time frame.",
                    advertisingPermission: "This filter includes only participants who have given valid advertising consent.",
                    postalCode: "This filter restricts participants based on their address. Use % as a wildcard, e.g., 022% for postal codes starting with 022.",
                    category: "This filter selects participants based on their category. Participants can either be included or excluded.",
                    advertisingBan: "This filter excludes participants who have an active advertising ban.",
                }, 
                label: {
                    filter_id: "Filter ID",
                    filterDays: "Filter days",
                    filterField: "Filter field",
                    filterValue: "Filter value",
                    filterOut: "Exclude from filter",
                },
                errors: {
                    configIncomplete: 'Incomplete Configuration'
                },
                updateSuccess: "Filter updated successfully.",
                updateFilter: "Filter {{current}} of {{total}} calculated"
            },
            info: {
                title: "Overview"
            }, 
            label: {
                description: "Description",
                name: "Name",
                type: "Type",
                start_date: "Start date",
                end_date: "End date",
                created_at: "Creation date",
                updated_at: "Last update",
                status: "Status",
                max_capacity: "Max capacity",
                communication_plan_id: "Communication Plan",
                scheduler_id: "Scheduler",
            },
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                type: "Change type for all {{selected}}",
                status: "Change status for all {{selected}}",
                delete: "Delete all {{selected}}"
            },
            new: "New event",
            phonePanel: {
                title: "Phone Campaign",
                status: {
                    done: "Done",
                    failed: "Not Reached"
                }
            },
            no_end_date: "No end date",
            scheduler: {
                title: "Scheduler",
                scheduleStatus: {
                    no_schedule: "No schedule",
                    calculating: "Calculating",
                    ready: "Schedule ready",
                    outdated: "Schedule outdated",
                },
            },
            search: {
                button: "Search event",
                placeholder: "Search...",
            },
            warn: {
                addParticipants: "Please add participants",
                selectCommunicationPlan: "Please select a communication Plan",
                selectScheduler: "Please select a scheduler",
            },
            tab: {
                all: "All events",
                upcoming: "Upcoming events",
                deleted: "Deleted events",
            },
            table: {
                select: "Select",
                description: "Description",
                name: "Name",
                type: "Type",
                start_date: "Start Date",
                end_date: "End Date",
                status: "Status",
                max_capacity: "Maximum Capacity",
                delete: ""
            },
            type: {
                email: "Email",
                phone: 'Phone',
                workshop: "Workshop",
                webinar: "Webinar",
                demo: "Demo",
                training: "Training",
            },
            status: {
                planned: "Planned",
                running: "Running",
                finished: "Finished",
                canceled: "Canceled",
            },
            unlimited_capacity: "Unlimited capacity",
            upload: "Upload events",
        },
        event_participants: {
            label: {
                status: "Status",
                event_id: "Event",
                contact_id: "Contact",
                email_id: "Email",
                notes: "Notes",
                review_notes: "Review notes",
                created_at: "Created at",
                planned_date: "Planned date",
            },
            options: {
                status: {
                    open: "Open",
                    approved: "Approved",
                    failed: "Revise",
                    creating: "Creating",
                    queued: "Queued",
                    in_ai_review: "In AI Review",
                },
            },
        },
        schedulers: {
            emptyList: "No schedulers found",
            emptyListTab: "No schedulers found in \"{{tab}}\"",
            search: {
                placeholder: "Search..."
            },
            tab: {
                all: "All schedulers",
                deleted: "Deleted"
            },
            table: {
                select: "Select",
                name: "Name",
                start_time: "Start time",
                end_time: "End time",
                messages_per_hour: "Emails per hour",
                messages_per_day: "Emails per day",
                delete: ""
            },
            input: {
                name: "Name",
                timezone: "Timezone",
                sendDays: "Send on these days",
                skipDays: "Skip these dates (e.g. public holidays)",
                breaks: "Daily breaks (no sending)",
                breakTo: "to"
            },
            weekdays: {
                monday: "Monday",
                tuesday: "Tuesday",
                wednesday: "Wednesday",
                thursday: "Thursday",
                friday: "Friday",
                saturday: "Saturday",
                sunday: "Sunday",
                mon: "Mon",
                tue: "Tue",
                wed: "Wed",
                thu: "Thu",
                fri: "Fri",
                sat: "Sat",
                sun: "Sun"
            }
        },
        emails: {
            dropdown: {
                allAccountSettings: "All Email Addresses",
                selectAccountSetting: "Select an Email Address"
            },
            emptyList: "No emails found",
            emptyListTab: "No emails found in \"{{tab}}\"",
            label: "Emails",
            search: {
                placeholder: "Search..."
            },
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                owner_user_id: "Change owner for all {{selected}}",
                workflow_status: "Change status for all {{selected}}",
                delete: "Delete all {{selected}}",
                isRead: "Mark all {{selected}} as read"
            },
            scheduler: {
                refresh: "Update participant data",
                scheduleEmails: "Schedule emails",
                write: "Write emails",
                writeFailed: "Failed to write emails",
                approveAll: "Approve all",
                reviewAndApproveAll: "Review and approve all",
                approveSuccess: "{{count}} participant(s) approved",
                approveNone: "No participants with a draft email to approve",
                updateTimes: "Update send times",
                clearTimes: "Clear send times",
                refreshSchedule: "Refresh schedule status",
                start: "Send campaign",
                pause: "Pause campaign",
                stop: "Stop campaign",
                checkAndDeleteDuplicates: "Check for duplicates",
                confirmCheckAndDeleteDuplicates: "Are you sure you want to check for duplicates? Emails will be compared by subject and duplicates will be deleted.",
                confirmWrite: "Are you sure you want to create draft emails for all open participants? You can review them before sending.",
                confirmApproveAll: "Are you sure you want to approve all created draft emails for sending?",
                confirmReviewAndApproveAll: "Are you sure you want AI to proofread and approve or reject all open draft emails?",
                confirmStart: "Are you sure you want to send the prepared emails? Scheduled send times will be applied and emails will go out.",
                confirmPause: "Are you sure you want to pause this email campaign?",
                confirmStop: "Are you sure you want to stop this email campaign?"
            },
            tab: {
                all: "All",
                deleted: "Deleted",
                sent: "Sent",
                unread: "Unread",
                draft: "Drafts",
                suggested: "Suggestions",
                scheduled: "Scheduled",
                mixed: "Mixed",
                reply_status: "Reply Status",
                bounce: "Bounce",
                customer_replied: "Replied",
                pending: "Pending"
            },
            table: {
                select: "Select",
                owner_user_id: "Owner",
                workflow_status: "Status",
                date: "Received Date",
                dateMixed: "Date",
                from_name: "Sender",
                subject: "Subject",
                sentDate: "Sent",
                sendDate: "Scheduled",
                createDate: "Created",
                approve: "Approve",
                reject: "Reject",
                to: "To",
                delete: "",
                isRead: ""
            },
            toolbar: {
                back: "Back to Email List",
                delete: "Delete Email",
                unread: "Mark as Unread",
                reply: "Reply",
                toggleAIPanel: "Toggle AI Panel",
                undo: "Undo Typing",
                redo: "Redo Typing",
                attach: "Add Attachment",
                emailView: "Go to Email View",
                calendarView: "Go to Calendar View",
                original: "Previous Message",
                massEmail: "Mass Email",
                individualEmail: "Individual Email"
            },
            ai: {
                recalculate: "Write an email",
                reformulate: "Edit request for this email",
                send: "Send Email",
                speak: "Speak Command"
            },
            new: "Compose New Email",
            sent: "Email Submitted",
            upload: "Upload Emails"           
        },
        emailAddress: {
            title: "Email Addresses", 
            add: "Add Email Address",
            label: {
                email_address: "Email Address",
                email_type: "Type",
                is_primary: "Is Primary Email Address"
            }
        },
        emailEdit: {
            button: {
                empty: "Discard Draft"
            },
            options: {
                formality: {
                    informal: "Informal",
                    formal: "Formal"
                },
                tone: {
                    angry: "Angry",
                    playful: "Playful",
                    friendly: "Friendly",
                    professional: "Professional",
                    empathetic: "Empathetic",
                    neutral: "Neutral"
                },
                levelOfDetail: {
                    brief: "Brief",
                    detailed: "Detailed",
                    stepByStep: "Step-by-Step",
                    overview: "Overview",
                    comprehensive: "Comprehensive"
                },
                cta: {
                    replyRequired: "Reply Required",
                    clickLink: "Click a Link",
                    provideFeedback: "Provide Feedback",
                    scheduleMeeting: "Schedule a Meeting",
                    makePayment: "Make a Payment"
                }
            },
            considerNot: {
                customer: "DO NOT use AI analysis of the customer",
                notes: "DO NOT use notes",
                knowledge: "DO NOT use knowledge"
            },
            consider: {
                customer: "Use AI analysis of the customer",
                notes: "Use notes",
                knowledge: "Use knowledge"
            },
            label: {
                formality: "Formality",
                tone: "Tone",
                purpose: "Purpose",
                levelOfDetail: "Level of Detail",
                cta: "Call to Action",
                template: "Template",
                language: "Language"
            },
            sections: {
                aiControl: "Update email with AI"
            }
        },
        emailInputBar: {
            add: "Add {{key}}",
            placeholder: "Type email addresses",
            emptyResult: "No matches found"
        },
        emailScheduler: {
            header: {
                preview: "Sende-Vorschau"
            },
            labels: {
                count: "#",
                dateTime: "Planned",
                planned: "Planned",
                scheduled: "Scheduled",
                name: "Name",
                email: "E-Mail",
                notes: "Notes",
                reviewNotes: "Review notes",
                phone: "Phone",
                status: "status",
                emailStatus: "Email status",
                notPlanned: "...",
                notScheduled: "—",
                viewEmail: "View email"
            },
            emailStatus: {
                draft: "Draft",
                suggested: "Suggested",
                scheduled: "Scheduled",
                sending: "Sending",
                sent: "Sent",
                to_revise: "To revise",
                canceled: "Canceled",
                canceling: "Canceling",
                error: "Error",
                received: "Received",
            },
            input: {
                earliestTime: "Don't send emails before...",
                latestTime: "Don't send emails after...",
                emailsPerHour: "Don't send more emails per hour then...",
                dailyEmailLimit: "Don't send more emails per day then...",
                update: "Refresh"
            },
            updating: "Updating send times...",
            working: "Working...",
            noParticipants: "No Participants found",
            invalidPlannedDates: "Some participants have missing or past send times. Recalculate the schedule before writing or sending.",
            progress: {
                summary: "{{created}} / {{total}} emails created",
                created: "Created",
                due: "Due",
            },
        },
        emoticonPicker: {
            pick: "Pick Icon"
        },     
        eventCommunication: {
            header: {
                preview: "Communication"
            },
            labels: {
                count: "#",
                dateTime: "Datum & Uhrzeit",
                name: "Name",
                email: "Email",
                status: "State",
            },
        },
        error: {
            authentication: "An error occurred during authentication",
            loadingSettings: "An error occurred while loading user settings",
            errorPage: {
                title: "Page Not Found",
                message: "An error occurred. Please check your internet connection."
            },
            apiError: {
                title: "We have a problem.",
                message: "We're having trouble connecting. Please try again."
            },
            duplicateRecord: "Duplicate records are not allowed",
            noAccess: {
                title: "No Access",
                message: "You do not have access to the requested application. Please contact your administrator."
            },
            noVideoSupport: "Your browser does not support videos.",
            action: {
                retry: "Retry"
            },
            unsupportedMedia: "No preview available",
            contactAdminButton: "Contact Administrator",
            invalidAccessRule: "Invalid access rule",
            invalidJson: "Invalid JSON"
        },
        feedback: {
            submit: "Feedback teilen"
        },
        homeButton: "To Home Screen",
        import: {
            alert: {
                error: "Error in Import File",
                exporting: "Exporting Conversation Tree",
                updating: "Uploading"
            },
            title: "Import Preview",
            type:{
                Person: "Contact",
                Address: "Address",
                addresses: "Addresses",
                companies: "Companies",
                company_financials: "Financial Data"
            },
            label: {
                primary: "Primary Object"
            }
        },
        interaction: {
            done: "Done",
            showDetails: "Show details",
            title: "Customer Interactions",
            add: "Document another Interaction",
            provideSummary: "Interaktion Summary",
            label: {
                id: "ID",
                type: "Interaction Type",
                tags: "Tags",
                summary: "Summary",
                call_direction: "Call Direction",
                contact_id: "Contact ID",
                related_contacts: "Related Contacts",
                user_id: "User ID",
                outcome: "Outcome",
                recording_url: "Recording URL",
                transcript: "Transcript",
                status: "Status",
                phone_number: "Phone Number",
                start_time: "Start Time",
                end_time: "End Time",
                duration: "Duration",
                tenant_id: "Tenant ID",
                is_deleted: "Deleted",
                created_at: "Created At",
                updated_at: "Updated At"
            }, 
            option: {
                call: "Call",
                video_call: "Video Call",
                in_person: "In Person",
                inbound: "Inbound",
                outbound: "Outbound",
                scheduled: "Scheduled",
                completed: "Completed",
                missed: "Missed",
                canceled: "Canceled",
                in_progress: "In Progress",
                ordered: "Ordered",
                request_more_information: "Request More Information",
                customer_not_interested: "Customer Not Interested",
                follow_up_scheduled: "Follow-up Scheduled",
                converted_to_opportunity: "Converted to Opportunity",
                issue_resolved: "Issue Resolved",
                pending_decision: "Pending Decision",
                escalated: "Escalated",
                no_show: "No Show",
                referred: "Referred",
                complaint_logged: "Complaint Logged"
            },
            type: "Type",
            tags: "Tags",
            summary: "Summary",
            call_direction: "Call Direction",
            contact: "Primary Contact",
            related_contacts: "Additional Contacts",
            user: "User",
            outcome: "Outcome",
            recording_url: "Recording URL",
            transcript: "Transcript",
            status: "Status",
            phone_number: "Phone Number",
            start_time: "Start Time",
            end_time: "End Time",
            duration: "Duration",
            created_at: "Created At",
            updated_at: "Updated At"
        },   
        integrations: {
            emptyList: "No integrations found",
            emptyListTab: "No integrations found in \"{{tab}}\"",
            label: {
                name: "Name",
                endpoint: "Endpoint",
                description: "Description",
                method: "Method",
                auth_required: "Authentication Required",
                response_format: "Response Format",
                enabled: "Active",
                interval: "Interval",
                last_run_at: "Last Run",
                last_processed_key: "Last Processed Key",
                is_deleted: "Deleted",
                created_at: "Created At",
                secret: "Secret"
            },
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                delete: "Delete all {{selected}}"
            },
            new: "New Integration",
            search: {
                button: "Search Integration",
                placeholder: "Search..."
            },
            tab: {
                all: "All Integrations",
                deleted: "Deleted Integrations"
            },
            table: {
                select: "Select",
                name: "Name",
                endpoint: "Endpoint",
                method: "Method",
                enabled: "Active",
                last_run_at: "Last Run",
                delete: ""
            },
            upload: "Upload Integrations"
        },   
        interactions: {
            search: {
                placeholder: "Search..."
            },
            emptyList: "No interactions found",
            emptyListTab: "No interactions found in \"{{tab}}\"",
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                user_id: "Change author for all {{selected}}",
                delete: "Delete all {{selected}}"
            },
            new: "Create New Interaction",
            upload: "Upload Interactions",
            label: "Interactions",
            tab: {
                all: "All Interactions",
                deleted: "Deleted Interactions"
            },
            title: "Title",
            table: {
                select: "Select",
                type: "Type",
                tags: "Tags",
                contact_id: "Contact",
                user_id: "Author",
                status: "Status",
                created_at: "Created",
                delete: ""
            },
            toolbar: {
                call: "Start Call"
            }
        }, 
        knowledge: {
            addKnowledge: "Create Background Knowledge",
            emptyList: "No background knowledge found",
            emptyListTab: "No background knowledge found in \"{{tab}}\"",
            ignore: "Ignore",
            label: {
                id: "ID",
                topic: "Topic",
                keywords: "Keywords",
                source: "Source",
                created_at: "Created At",
                updated_at: "Last Updated",
                source_section: "Source Section",
                is_active: "Is Active",
                type: "Type",
                prompt: "Analysis Prompt"
            },
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                delete: "Delete all {{selected}}"
            },
            msg: {
                processing: "The data is being processed. This may take a while..."
            },
            new: "Add New Background Knowledge",
            noLinesAvailable: "No background knowledge configured",
            plain: "Original Text",
            summary: "Summary",
            title: "Background Knowledge",
            updated: "Summary Created",
            updating: "Creating Summary",
            table: {
                select: "Select",
                topic: "Topic",
                keywords: "Keywords",
                created_at: "Created At",
                updated_at: "Last Updated",
                is_active: "Active",
                delete: ""
            },
            search: {
                placeholder: "Search..."
            },
            tab: {
                all: "All",
                deleted: "Deleted"
            }
        },
        lineItem: {
            label: {
                product_id: "Product ID",
                type: "Type",
                quantity: "Quantity",
                list_price: "List Price",
                unit_price: "Unit Price",
                description: "Description",
                created_at: "Created At",
                delivery_date: "Delivery Date",
                expires_at: "Expires At"
            },
            options: {
                type: {
                    sales: "Sales",
                    subscription: "Subscription",
                    rent: "Rent"
                }
            },
            title: "Line Items",
            button: {
                addLineItem: "Add Line Item"
            }
        },
        link: {
            label: {
                home: "Go to Home"
            }
        },
        list: {
            deselectAll: "Deselect All",
            selectAll: "Select all",
            showFilters: "Show Fitlers",
            hideFilters: "Hide Filter",
            total: "Total",
            noTab: "Search in all tabs"
        },
        log_center: "Recent Activity",
        log: {
            table: {
                source: "Module",
                created_at: "created_at",
                message: "Message"
            },
            search: {
                placeholder: "Search..."
            },
            emptyList: "No Log Messages found",
        },
        login: {
            register: "Register",
            button: "Log In",
            title: "Mainition AI Platform",
            invitationHeadline: "Welcome!",
            invitationSubline: "Your invitation is being verified...",
            errorToken: "No valid invitation found"
        },
        menu: {
            ai_control: "AI Settings",
            avatars: "Avatars",
            chat_designs: "Chat Designs",
            chat_sessions: "Chat Sessions",
            chats: "Chats",
            companies: "Companies",
            communication_plans: "Communication Plans",
            contracts: "Contracts",
            crm: "Relationships",
            customers: "Contacts",
            dashboard: "Dashboard",
            documents: "Documents",
            account_settings: "Account Settings",
            emails: "Emails",
            events: "Campaigns",
            event_participants: "Event Participants",
            schedulers: "Schedulers",          
            import_data: "Import Data",                         
            interactions: "Interactions",
            integrations: "Integrations",
            knowledge: "Knowledge Base",
            languagePictureAlt: "Current language flag: German",
            logout: "Logout",
            marketing: "Mass Outreach",
            message_templates: "Templates",
            metadata: "Metadata",                               
            notes: "Notes",
            oms: "Order Management",
            orders: "Orders",
            products: "Products",
            profile: "Profile",
            profilePictureAlt: "Profile Picture",
            prompts: "Prompts",                                 
            roles: "Roles / Permissions",
            searchPlaceholder: "SEARCH",
            settings: "Settings",
            settingsWizard: "Setup Wizard",
            signatures: "Signatures",
            switchApp: "Switch App",
            tenants: "Tenants",
            term_corrections: "Term Corrections",               
            todos: "Todos",
            training: "AI Training",
            uploads: "Uploads",
            users: "Users",
            savvyspeak: "SavvySpeak",
            speicherfuchs: "Speicherfuchs"
        },              
        message_templates: {
            emptyList: "No message templates found",
            emptyListTab: "No message templates found in \"{{tab}}\"",
            new: "New Message Template",
            search: {
                button: "Search Template",
                placeholder: "Search..."
            },
            tab: {
                all: "All Templates",
                deleted: "Deleted Templates"
            },
            label: {
                title: "Title",
                subject: "Subject",
                body: "Message Content",
                category: "Category",
                created_at: "Created At",
                updated_at: "Last Updated",
                is_active: "Active Status"
            },
            table: {
                title: "Title",
                subject: "Subject",
                category: "Category",
                created_at: "Created At",
                updated_at: "Last Updated",
                is_active: "Active Status",
                delete: ""
            },
            upload: "Upload Message Templates"
        },        
        notes: {
            search: {
                placeholder: "Search..."
            },
            comment: "Comment on the Note",
            content: "Note",
            emptyList: "No notes found",
            emptyListTab: "No notes found in \"{{tab}}\"",
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                user_id: "Change author for all {{selected}}",
                delete: "Delete all {{selected}}"
            },
            new: "Create New Note",
            upload: "Upload Notes",
            noTitle: "n/a",
            label: "Notes",
            tab: {
                all: "All Notes",
                deleted: "Deleted"
            },
            title: "Title",
            table: {
                select: "Select",
                title: "Tagline",
                email_id: "Email",
                contact_id: "Contact",
                user_id: "Author",
                created_at: "Created",
                delete: ""
            }
        },
        note: {
            title: "Title",
            relatedContact: "Contact",
            content: "Content",
            type: "Type",
            created_at: "Created At",
            updated_at: "Last Updated",
            comment: "Comment"
        },
        notifications: {
            emailSent: "Email send",
            noNewNotifications: "No new notifications",
            newEmailsReceived: "new emails received",
            newEmailsAnalyzed: "New email analyzed",
            iconLabel: "Notifications",
        },
        orders: {
            search: {
                placeholder: "Search..."
            },
            tab: {
                all: "All Orders",
                deleted: "Deleted Orders"
            },
            emptyList: "No orders found",
            emptyListTab: "No orders found in \"{{tab}}\"",
            label: {
                list: "Order",
                order_number: "Invoice No.",
                customer_first_name: "Customer First Name",
                customer_last_name: "Customer Last Name",
                total_amount: "Total Amount",
                net_amount: "Net Amount",
                tax_amount: "Tax Amount",
                status: "Status",
                created_at: "Created At",
                updated_at: "Last Updated",
                address: "Address",
                invoice: "Invoice",
                contact_id: "Customer"
            },
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                status: "Change status for all {{selected}}",
                delete: "Delete all {{selected}}"
            },
            options: {
                status: {
                    pending: "Pending",
                    shipped: "Shipped",
                    delivered: "Delivered",
                    canceled: "Canceled"
                }
            },
            table: {
                select: "Select",
                customer: "Contact",
                order_number: "Invoice No.",
                contact_id: "Customer",
                total_amount: "Total Amount",
                net_amount: "Net Amount",
                tax_amount: "Tax Amount",
                status: "Status",
                created_at: "Created At",
                updated_at: "Last Updated",
                address: "Address",
                delete: ""
            },
            new: "Create Order",
            upload: "Upload Order"
        },
        phoneNumber: {
            title: "Phone Numbers", 
            add: "Add Phone Number",
            call: "Call",
            label: {
                phoneNumber: "Phone Number",
                phoneType: "Label",
                isPrimary: "Primary Phone Number"
            }
        },
        products: {
            emptyList: "No products found",
            emptyListTab: "No products found in \"{{tab}}\"",
            label: {
                description: "Description",
                name: "Name",
                sku: "SKU",
                category: "Category",
                list_price: "List Price",
                created_at: "Created At",
                updated_at: "Last Updated",
                is_active: "Active",
                image_url: "Image URL"
            },
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                delete: "Delete all {{selected}}"
            },
            new: "New Product",
            search: {
                button: "Search Product",
                placeholder: "Search..."
            },
            tab: {
                all: "All Products",
                deleted: "Deleted Products"
            },
            table: {
                select: "Select",
                description: "Description",
                name: "Name",
                sku: "SKU",
                category: "Category",
                list_price: "List Price",
                delete: ""
            },
            upload: "Upload Products"
        },   
        prompts: {
            label: {
                goal: 'Goal',
                botname: 'Bot Name',
                role: 'Role',
                task: 'Task',
                tone: 'Tone',
                maxlength: 'Max Length'
            },
            options: {
                Duzen: 'Casual',
                Siezen: 'Formal'
            },
            titel: {
                conversationStage: 'Conversation Stage Configuration'
            }
        },         
        diagrams: {
            data: {
                received: "Received Emails",
                suggested: "Suggested Emails",
                sent: "Sent Emails"
            },
            label: {
                received: "Received",
                suggested: "Suggested",
                sent: "Sent"
            },
            period: {
                daily: "Day",
                monthly: "Month"
            },
            title: {
                emails: "eMails",
            }
        },
        objectSelector: {
            remove: "Remove Link",
            removeConfirm: "Are you sure you want to remove the link?",
            searchAndSelect: "Search and select an object...",
            noResults: "No objects found"
        },
        relatedLists: {
            metric: {
                open: "Open",
                inProgress: "In Progress",
                done: "Done",
                all: "All",
                pending: "Pending",
                canceled: "Canceled",
                received: "Received",
                sent: "Sent",
                scheduled: "Scheduled",
                suggested: "Suggested"
            }
        },
        reports: {
            label: {
                number: "Number",
                usd: "USD"
            },
            title: {
                CompaniesTotal: "Available Companies",
                CommunicationPotential: "Communication Potential",
                runningCommunication: "Ongoing Communication",
                companyDetails: "Company Details"
            },
            kpis: {
                deleted_companies: "Deleted",
                total_companies: "Total Companies",
                active_companies: "Active Companies",
                total_emails: "Available Email Addresses",
                unique_emails: "Unique Email Addresses",
                duplicate_emails: "Duplicates",
                companies_with_email: "Email Sent",
                companies_without_email: "No Email Sent",
                invited: "Invited",
                emptySeats: "Available Spots",
                pass: "Included",
                filtered: "Excluded"
            }
        },       
        roles: {
            title: "Permissions / Roles",
            label: {
                name: "Name",
                description: "Description"
            },
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                delete: "Delete all {{selected}}"
            },
            permissions: {
                title: "Permissions",
                resource_type: "Object",
                access_filter: "Access Rule",
                access_read: "Read",
                access_write: "Write",
                select: "Select",
                addPermission: "Add Permission",
                addAll: "Add All",
                refresh: "Update"
            },
            tab: {
                all: "All Roles",
                deleted: "Deleted Roles"
            },
            search: {
                placeholder: "Search..."
            },
            table: {
                select: "Select",
                name: "Name",
                description: "Description",
                delete: ""
            },
            emptyList: "No roles found",
            emptyListTab: "No roles found in \"{{tab}}\"",
            new: "Create New Role",
            upload: "Upload Roles"
        },
        select: {
            folder: "Select a folder on the server to store your sent emails..."
        },
        sentiment: {
            angry: "Angry",
            veryAngry: "Very angry"
        },
        setting: {
            avatar: {
                images: "Avatar Images",
                upload: "Upload Avatar Image",
                name: "Name",
                title: "Title",
                is_enabled: "Enabled",
                description: "Description",
                image_url: "Image",
                video_url: "Video"
            },
            error: {
                "[Errno 61] Connection refused": "Wrong credentials",
                "authentication failed": "Authentication to Email server failed",
                "Decryption failed for provided credentials": "Please provide a password",
                "Did not find email credentials": "Missing credentials",
                noEmail: "Please enter your email"
            },
            label: {
                authMethod: "Authentication Method",
                assistant_language: "Assistant Language",
                assistant_name: "Assistant Name",
                assistant_talking: "Assistant Speaking",
                avatarEnabled: "Show DID Avatar",
                avatarHeight: "Avatar Height",
                avatarImage: "Avatar Image",
                avatarName: "Avatar Name",
                avatarWidth: "Avatar Width",
                check_spam: "Enable Spam Check",
                companyLogo: "Company Logo",
                conversationHeadline: "Conversation Headline",
                conversationOpeningText: "Conversation Opening Text",
                conversationSubline: "Conversation Subline",
                description: "Description",
                dIdFullBody: "DID Full Body",
                dIdKey: "DID Key",
                elevenLabsKey: "Eleven Labs Key",
                dIdVoiceID: "DID Voice ID",
                email_download_start_date: "Start date for downloading emails from server",
                email: "Email",
                from_name: "Name used as sender for emails",
                username: "Username",
                imap: "IMAP",
                is_active: "Active",
                is_default: "Default",
                is_single_selection: "Only one category can be assigned",
                name: "Category Name",
                notesEnabled: "Notes Enabled",
                object_type: "Object for which the categorization is created",
                password: "Password",
                requires_analysis: "Emails in this category should be analyzed",
                requires_response: "Emails in this category should be responded to",
                saveConversationQuestion: "Question for saving the conversation",
                seed: "Seed",
                smtp: "SMTP",
                text_analysis_length: "Number of characters to consider for categorization",
                logo: "Logo for the email account"
            },
            oauth: {
                success: "Authenticated Successfully"
            },
            task: {
                name: "Task Name",
                enabled: "Enabled",
                created_at: "Created At",
                last_run_at: "Last Run At",
                priority: "Priority",
                interval: "Interval"
            },
        },
        settings: {
            avatars: {
                title: "Choose your AI Consultant"
            },
            aitree: "Main Settings",
            backgroundTasks: {
                title: "Background Tasks"
            },
            button: {
                selectTenant: "Select Tenant"
            },
            classification_entries: {
                title: "Class"
            },
            classification_groups: {
                title: "Classifications"
            },
            emailFolder: {
                folder_name: "Folder Name",
                is_sent_folder: "Is Sent Folder",
                sync: "Sync emails from this Folder",
                is_deleted_folder: "Is Deleted Folder",
                is_primary_folder: "Auto sync",
                title: "Email Folder Settings",
                syncButton: "Refresh"
            },
            header: {
                createTenant: "Create New Tenant",
                selectTenant: "Select Tenant"
            },
            label: {
                createTenant: "Create Tenant",
                name: "Name",
                logo_upload_id: "Logo"
            },
            language: {
                title: "Choose your language!"
            },
            signature: {
                title: "Configure Email Signatures"
            },
            prompts: {
                title: "Configure Prompts"
            },
            phrases: {
                title: "Configure Phrases to be removed from chat"
            },
            section: {
                apis: "Integrations"
            },
            standardmessage: {
                name: "Standard Message Label",
                subject: "Subject",
                title: "Standard Messages"
            },
            tenantUsers: {
                title: "Users for this Tenant",
                invitations: "User Invitations",
                addInvitations: "Invite Users",
                email: "Email Address",
                status: "Status",
                expiry: "Valid Until",
                invited_by: "Invited By",
                copyLink: "Copy Invitation Link",
                statusPending: "Pending",
                statusAccepted: "Accepted",
                statusExpired: "Expired",
            },            
            user: {
                user_id: "User Id",
                first_name: "First Name",
                last_name: "Last Name"
            },
            userSettings: {
                title: "User Settings"
            },
            team: {
                title: "Manage Team Members"
            }
        },
        signature: {
            selectDefault: "Select as default"
        },
        signatures: {
            emptyList: "No signatures found",
            emptyListTab: "No signatures found in \"{{tab}}\"",
            label: {
                name: "Name",
                content: "Content",
                is_deleted: "Deleted",
                created_at: "Created At",
                updated_at: "Last Updated"
            },
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                delete: "Delete all {{selected}}"
            },
            new: "New Signature",
            search: {
                button: "Search Signature",
                placeholder: "Search..."
            },
            tab: {
                all: "All Signatures",
                deleted: "Deleted Signatures"
            },
            table: {
                select: "Select",
                name: "Name",
                content: "Content",
                delete: ""
            },
            upload: "Upload Signatures"
        },
        spam_threshold: "Sensitivity to identify spam",
        standardmessages: {
            addStandardmessages: "Set up standard messages",
            label: "Standard Messages",
            noLinesAvailable: "No Standard Messages set up"
        },
        stages: {
            label: {
                set_for_test: "Include in Test",
                target_type: "Target Type",
                target_percentage: "Conversation Phase Goal Achievement (%)",
                target: "Conversation Phase Goal",
                target_prompt: "Description of Conversation Phase Goal",
                target_fields: "Information to Collect"
            },
            options: {
                select: "End of Conversation",
                QualitativeAnswer: "Qualitative Question",
                Number: "Numeric",
                AskMultipleQuestions: "Information Query",
                Decision: "Decision (Yes / No)"
            },
            titel: {
                analytics: "Conversation Phase Transition"
            }
        },
        team: {
            label: {
                firstName: "First Name",
                lastName: "Last Name",
                email: "Email Address",
                phone: "Phone Number",
                role: "Role",
                department: "Department",
                createdAt: "Created At",
                active: "Active"
            }
        },
        tenants: {
            emptyList: "No tenants found",
            emptyListTab: "No tenants found in \"{{tab}}\"",
            label: {
                name: "Name",
                created_at: "Created At",
                is_setup_done: "Setup",
                logo_upload_id: "Logo",
                is_deleted: "Deleted"
            },
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                delete: "Delete all {{selected}}"
            },
            new: "New Tenant",
            search: {
                button: "Search Tenant",
                placeholder: "Search..."
            },
            tab: {
                all: "All Tenants",
                deleted: "Deleted Tenants"
            },
            table: {
                select: "Select",
                name: "Name",
                created_at: "Created At",
                is_setup_done: "Setup",
                logo_upload_id: "Logo",
                delete: ""
            },
            upload: "Upload Tenant",
            view: {
                list: "List View",
                tile: "Tile View"
            }
        },
        test: {
            graphError: {
                EdgeWithoutValidNodes: "There are Edges without valid nodes.",
                MissingTarget: "Validation failed: One or more nodes are missing a 'Target'.",
                MissingTargetField: "Validation failed: One or more edges are missing a target field.",
                MultipleStartNodes: "Validation failed: There should be only one start node.",
                MultipleTestActivated: "Validation failed: More than one node has 'Test Activated'."
            }
        },
        todo: {
            action: {
                refresh: "Refresh"
            },
            created_at: "Created At",
            description: "Description",
            due_date: "Due Date",
            emptyList: "No tasks found",
            emptyListTab: "No tasks found in \"{{tab}}\"",
            headline: "Headline",
            is_done: "Done",
            is_verified: "Verified",
            new: "Create New Todo",
            priority: "Priority",
            chat_id: "Project ID",
            responsible: "Owner",
            creator: "Creator",
            source_type: "Source",
            start: "Start",
            stop: "Stop",
            status: "Status",
            done: "Mark as Done",
            target: "Target",
            type: "Type",
            contact: "Relevant Contact",
            sourceEmail: "Email this task is based on",
            inProgressByAI: "This todo is currently being handled by your AI agent..."
        },
        todos: {
            emptyList: "No tasks found",
            emptyListTab: "No tasks found in \"{{tab}}\"",
            label: "Tasks",
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                responsible_user_id: "Change owner for all {{selected}}",
                delete: "Delete all {{selected}}"
            },
            new: "Create New Task",
            options: {
                status: {
                    open: "Open",
                    inProgress: "In Progress",
                    done: "Done"
                },
                prio: {
                    hight: "High",
                    middle: "Medium",
                    low: "Low"
                }
            },
            search: {
                placeholder: "Search..."
            },
            table: {
                select: "Select",
                contact_id: "Customer",
                status: "Status",
                due_date: "Due",
                headline: "Task",
                responsible_user_id: "Team",
                delete: ""
            },
            tab: {
                all: "All Todos",
                inProgress: "In Progress",
                "In Progress": "In Progress",
                done: "Done",
                deleted: "Deleted"
            },
            upload: "Upload Todos"
        },
        token: {
            usage: "Token"
        },
        toolbar: {
            back: "Back",
            delete: "Delete",
            undelete: "Undo Delete",
            showAIAgent: "Show AI Agent",
            hideAIAgent: "Hide AI Agent"
        },
        upload: {
            sse:{
                start: "Start Image Analysis",
                step: "Completed analysis for page {{count}} / {{total}}"
            },
        },
        uploads: {
            ai: {
                analyze: "Analyze Document",
                prepare: "Generate Import Preview",
                import: "Import Data"
            },
            emptyList: "No Uploads found",
            emptyListTab: "No uploads found in \"{{tab}}\"",
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                delete: "Delete all {{selected}}"
            },
            new: "Upload new document",
            search: {
                placeholder: "Search"
            },
            tab: {
                all: "All Uploads",
                deleted: "Deleted Uploads",
            },
            todo: "Upload Todos",
            table: {
                select: "Select",
                filename: "Name",
                status: "Status",
                created_at: "Created At",
                content_type: "Format",
                type: "Type",
                delete: ""
            }, 
            toolbar: {
                delete: "Delete",
                undelete: "Undo Delete"
            },
            label: {
                filename: "Filename",
                file_path: "File Path",
                content_type: "Content Type",
                is_public: "Share on Web",
                status: "Status",
                type: "Type",
                created_at: "Created At",
                defaultAlt: "User-uploaded media",
                dragDrop: "Drag files here or click to select files"
            },
            options: {
                status: {
                    pending: "Pending",
                    uploaded: "Uploaded",
                    parsed: "Parsed",
                    inMapping: "Mapping in Progress",
                    mapped: "Mapped",
                    inAnalyzing: "Analyzing",
                    analzed: "Analyzed"
                },
                contentType: {
                    pdf: 'PDF Document',
                    jpeg: 'JPEG Image',
                    pkcs7: 'Signed File (PKCS#7)',
                    png: 'PNG Image',
                    gif: 'GIF Image',
                    plain: 'Plain Text',
                    tnef: 'TNEF Attachment (MS-TNEF)'
                }
            }
        },
        used: {
            ai: {
                token: "Used AI Token"
            }
        },
        users: {
            roles: {
                AddUserRole: "Add Role",
                title: "Roles"
            },
            title: "User Data",
            invitation: {
                email: "Email",
                title: "Invitation",
                status: "Status",
                expiry: "Valid Until"
            },
            label: {
                first_name: "First Name",
                last_name: "Last Name",
                email: "Email",
                phone: "Phone"
            },
            object: {
                invistationStatus: {
                    pending: "Pending",
                    accepted: "Accepted",
                    expired: "Expired"
                }
            },
            multiSelect: {
                selectAll: "Select all {{total}}",
                deselectAll: "Deselect all {{total}}",
                delete: "Delete all {{selected}}"
            },
            tab: {
                all: "All Users",
                deleted: "Deleted Users"
            },
            search: {
                placeholder: "Search..."
            },
            table: {
                select: "Select",
                first_name: "First Name",
                last_name: "Last Name",
                email: "Email",
                phone: "Phone",
                status: "Status",
                delete: ""
            },
            emptyList: "No users found",
            emptyListTab: "No users found in \"{{tab}}\"",
            new: "Add New User",
            upload: "Upload Users"
        },
        userSetting: {
            analyze_all_contacts: "Analyze Emails from All Senders",
            auto_send_after_talking: "Auto-Send After Speaking",
            default_account_settings: "Default Email in List View",
            is_ai_control_visible: "Show AI Control Menu",
            is_assistant_talking: "Assistant Speaks Automatically",
            is_avatars_visible: "Show Avatars Menu",
            is_chat_sessions_visible: "Show Chat Sessions Menu",
            is_chats_visible: "Show Chats Menu",
            is_companies_visible: "Show Companies Menu",
            is_communication_plans_visible: "Show Communication Plans Menu",
            is_contracts_visible: "Show Contracts Menu",
            is_customers_visible: "Show Customers Menu",
            is_documents_visible: "Show Documents Menu",
            is_account_settings_visible: "Show Email Settings Menu",
            is_emails_visible: "Show Emails Menu",
            is_events_visible: "Show Events Menu",
            is_event_participants_visible: "Show Event Participants Menu",
            is_schedulers_visible: "Show Schedulers Menu",    
            is_import_data_visible: "Show Import Data Menu",                  
            is_integrations_visible: "Show Integrations Menu",
            is_interactions_visible: "Show Interactions Menu",
            is_knowledge_visible: "Show Knowledge Library Menu",
            is_message_templates_visible: "Show Message Templates Menu",
            is_metadata_visible: "Show Metadata Menu",                        
            is_notes_visible: "Show Notes Menu",
            is_orders_visible: "Show Orders Menu",
            is_products_visible: "Show Products Menu",
            is_profile_visible: "Show Profile Menu Item",
            is_prompts_visible: "Show Prompts Menu",                           
            is_roles_visible: "Show Roles / Permissions Menu",
            is_settings_visible: "Show Settings Menu",
            is_signatures_visible: "Show Signatures Menu",
            is_term_corrections_visible: "Show Term Corrections Menu",         
            is_todos_visible: "Show Tasks Menu",
            is_uploads_visible: "Show Uploads Menu",
            is_users_visible: "Show Users Menu",
            list_page_length: "List Items per Page",
            show_icons: "Show Descriptions as Icons"
        },        
        AI_Evaluation: "AI Evaluation",
        ai_settings: "AI Settings",
        analytics_temperature: "Temperature",
        analytics_text: "Prompt for Analytical LLM",
        app_name: "Mainition AI Platform",
        chat_avatar: "Avatar",
        chat_branding: "Website-Branding",
        Chat_Materials: "Manage Multimedia Materials",
        chat_settings: "Chat Settings",
        chat_Texts: "Static Texts",
        chat_voice: "Voice",
        Chats: "Chats",
        Completed_Tasks: "Completed Tasks",
        condition_field: "Field Type for Decision",
        condition_value: "Field Value for Decision",
        Configure_AI: "Configure the AI-Assistant",
        conversationstage: {
            actions: "Connection Effects",
            analyticalLLM: "Analytical LLM",
            analytics: "Transition",
            api: "API / Integration",
            conditions: "Connection Conditions",
            configuration: "Conversation Management",
            connection: {
                title: "Configure Conversation Transitions",
                createCustomer: "Create Contact",
                createDossier: "Create Customer Dossier",
                conditionField: "Transition Condition",
                conditionValue: "Transition Value"
            },
            conversation: "Conversation Stage Configuration",
            conversationalLLM: "Conversational LLM",
            data: "Settings",
            input: "Input / Background",
            test: "Test Configuration",
        },
        Current_Chats: "Current Chats",
        Daily_Sales: "Daily Sales",
        deals: "Deals",
        dont_show: "Don't Show",
        email_alert_fetchEmails: "Fetching new Emails",
        email_assistant: "Email Assistant",
        email_list_header: "Current Emails",
        Goal: "Goal",
        Input: "Input / Background",
        is_active: "Active",
        key_management: "Software-Keys",
        keywords: "Key Words",
        knowledge_settings: "Knowledge Integrations",
        label: {
            firstname: "First name",
            lastname: "Last Name",
            email: "Email",
            phone: "Phone"
        },
        Last_Activity: "Last Activity",
        Lead_Score: "Lead Score",
        Leads: "Leads",
        length: "Response Length",
        llm: "AI",
        locale: "Locale",
        model: "Engine",
        Name: "Name",
        new_leads: "New Leads",
        prompt: "Processing Hints",
        field_name: "Technical Name",
        field_display_name: "Display Name",
        Role: "Role",
        Sales_Stage: "Sales Stage",
        Save: "Save",
        show: "Show",
        source_section: "CSS Class",
        source: "URL",
        Stage_Completion: "Stage Completion",
        stage_key: "Stage ID",
        target_fields: "Fields to be asked",
        target_percentage: "Target Achievement in Percentage",
        target_prompt: "Explanation Target",
        target_type: "Target Type",
        target: "Target",
        Task: "Task",
        temperature: "LLM Freedom",
        tenant: "Project",
        test_history: "Conversation History for Test",
        text: "Text",
        title_configure_conversation_flow: "Configure Conversation Flow",
        Tone: "Tone",
        topic: "Topic",
        Total_Engagements: "Total Engagements",
        Wizard:{
            Briefing: "Agent Briefing"
        },
        savvySpeak: {
            title: "Welcome to SavvySpeak",
            welcomeMessage: "Hello! I'm your teacher and I'll help you make fast progress!",
            dashboardCards: {
                exercise: {
                    title: "Practice Speaking",
                    text: "Practice speaking English with your avatar"
                },
                progress: {
                    title: "Learning Progress",
                    text: "See your current learning progress"
                },
                profile: {
                    title: "Your Data",
                    text: "Manage your personal data"
                },
                userManagment: {
                    title: "User Management",
                    text: "Invite students and teachers"
                }
            }
        },        
        speicherfuchs: {
            title: "Welcome to Speicherfuchs",
            welcomeMessage: "Hi! I'm Lina and I help you navigate the bureaucracy jungle.",
            dashboardCards: {
                yourData: {
                    title: "Your Data",
                    text: "Overview of your data"
                },
                uploadDocuments: {
                    title: "Upload Documents",
                    text: "Upload your notices and documents"
                },
                submitApplication: {
                    title: "Submit Application",
                    text: "Child benefits, SGB II, residence"
                },
                appointments: {
                    title: "Keep track of appointments & deadlines",
                    text: ""
                }
            }
        }      
    }
}